import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Card, Button, message, Divider, Space, Tag, Select } from "antd";
import { FileTextOutlined, FileDoneOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../components/headerPage";
import { HeaderTitle } from "../../components/headerTitle";
import { useNavigate, useSearchParams } from "react-router-dom";
import http from "../../services/http";
import dayjs from "dayjs";
import { TableCustom } from "../../components/table";
import { parseToInt } from "../../helpers/masks";

export const AceitesDocumentos = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tipo, setTipo] = useState(parseToInt(searchParams.get("tipo")));
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [tipos, setTipos] = useState([]);

  useEffect(() => {
    listarAceitesDocumentos();
    listarAceitesDocumentosTipos();
  }, []);

  const listarAceitesDocumentosTipos = async () => {
    setLoading(true);
    const api = await http("get", `v1/aceites_documentos_tipos/listar_ativos`, []);
    if (api.statusCode === 200) {
      let array_tipo = [{ label: "Todos", value: 0 }];
      for (let tp of api?.response?.data) {
        array_tipo.push({ label: tp?.descricao, value: tp?.id });
      }
      setTipos(array_tipo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const listarAceitesDocumentos = async () => {
    setLoading(true);
    const api = await http("get", `v1/aceites_documentos/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const columns = [
    {
      dataIndex: "tipo",
      title: "Tipo",
    },
    {
      dataIndex: "data_lancamento",
      title: "Data",
      render: (_, e) => dayjs(e.data_lancamento).format("DD/MM/YYYY"),
    },
    {
      dataIndex: "status_confirmacao",
      title: "Status Confirmação",
      render: (_, e) =>
        e.status_confirmacao === 1 ? <Tag color="green">Confirmado</Tag> : <Tag color="red">Pendente</Tag>,
      renderText: (e) => (e.status_confirmacao === 1 ? "Confirmado" : "Pendente"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      sorter: false,
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Button
            loading={loading}
            onClick={() => navigate(`/aceites-documentos/detalhes/${e.id}`)}
            icon={<FileTextOutlined />}>
            Visualizar
          </Button>
        </Space.Compact>
      ),
    },
  ];

  const filteredDados = useMemo(() => handleFilter(dados, tipo ?? 0), [dados, tipo]);

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
        <div className="content-item">
          <HeaderPage title="Documentos" onClickBack={() => navigate({ pathname: "/" })} />
          <HeaderTitle
            title="Aceites de Documentos"
            loading={loading}
            subtitle="Consultar meus documentos"
            icon={<FileDoneOutlined />}
          />
          <Divider />
          <Card bordered={false} bodyStyle={{ padding: "3%" }}>
            <TableCustom
              extraHeaderComponents={
                <Select
                  disabled={loading}
                  onChange={(val) => {
                    setSearchParams({ tipo: val });
                    setTipo(val);
                  }}
                  value={tipo ?? 0}
                  placeholder="Selecione o status"
                  style={{ minWidth: 180 }}
                  options={tipos}
                />
              }
              loading={loading}
              columns={columns}
              dataSource={filteredDados}
              rowKey="id"
            />
          </Card>
        </div>
      </Col>
    </Row>
  );
};

const handleFilter = (data, tipo_filter) => {
  if (data?.length === 0) {
    return [];
  }
  let filteredData = data;
  if (tipo_filter > 0) {
    filteredData = filteredData?.filter((d) => d?.id_aceites_documentos_tipos === tipo_filter);
  }

  return filteredData;
};
